import * as Portal from '@radix-ui/react-portal'

import { X } from 'phosphor-react'
import { useState } from 'react'

import logo from '../../../../assets/svgs/logo.svg'

import { Link } from 'react-router-dom'
import { BurguerMenuButton } from '../../../../components/BurguerMenuButton'
import { cn } from '../../../../utils/cn'
import { LanguageDropdown } from './LanguageDropdown'
import { LoginDropdown } from './LoginDropdown'
import { Navigation } from './Navigation'

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState)
  }

  return (
    <header className="fixed z-50 bg-[#001D2F] w-full h-[88px]">
      <div className="w-full flex items-center justify-between px-4 py-4 mx-auto font-semibold text-white uppercase max-w-7xl">
        <Link to="/">
          <img
            src={logo}
            className="w-24 lg:w-[134px]"
          />
        </Link>

        <div className="flex gap-9 lg:hidden">
          <div className="flex gap-4">
            <LoginDropdown />
            <LanguageDropdown />
          </div>

          <BurguerMenuButton onOpenMenu={toggleMobileMenu} />
        </div>

        <Portal.Root
          className={cn(
            'hidden z-50 fixed top-0 bottom-0 left-0 right-0 bg-[#001D2F] px-4 pt-4',
            { block: isMobileMenuOpen }
          )}
        >
          <div className="flex items-center justify-between mb-10">
            <img 
              src={logo} 
              className="w-24" />
            <button type="button" onClick={() => setIsMobileMenuOpen(false)}>
              <X size={32} className="text-grey-700" />
            </button>
          </div>

          <Navigation variant="mobile" setIsMobileMenuOpen={setIsMobileMenuOpen} />
        </Portal.Root>

        <Navigation variant="desktop" />

        <div className="hidden gap-10 lg:flex">
          <LoginDropdown />
          <LanguageDropdown />
        </div>
      </div>
    </header>
  )
}
